import {
  Alert,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TabsList from "../../ui/TabsList";
import CustomTable from "../../ui/CustomTable";
import { useAuth } from "../../services/auth";
import styled from "styled-components";
import { useCompany } from "../Companies/Provider";
import { useNFC } from "./providers";
import { useParams } from "react-router-dom";
import TagCode from "./Render/TagCode";
import TagType from "./Render/TagType";
import Free from "./Render/Free";
import Active from "./Render/Active";
import { useSite } from "../Sites/Provider";
import { PlanEnum } from "../../utilities/Enum";

import { createYupSchema } from "../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FilterFields from "./FilterFields";
import { FilterList } from "@mui/icons-material";

const yupSchema = FilterFields.reduce(createYupSchema, {
  id: Yup.number(),
  pid: Yup.number()
    .nullable(true)
    .typeError()
    .transform((_, val) => (val ? Number(val) : null)),
});
const formSchema = Yup.object().shape(yupSchema);

const GridGroup1 = styled.div`
  width: fit-content;
  display: grid;
  padding: 20px;
  padding-bottom: 40px;
  margin-bottom: 10px;
  grid-template-columns: 325px 225px;
  gap: 10px;
  grid-template-rows: 75px;
  grid-column-gap: 10px;
`;

const NFCPage = () => {
  let theme = useTheme();

  const [selectedCols, setSelectedCols] = useState("NFC");
  const [error, setError] = useState();

  const { role, adminOn } = useAuth();
  const { name } = useParams();
  const [reload, setReload] = useState(false);
  const [CompanyId, setCompanyId] = useState();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const {
    state: { Names: companies },
    fetchNames: fetchCompany,
  } = useCompany();
  const {
    state: { Names: sites, selected: site },
    fetchSiteNames: fetchSites,
  } = useSite();
  const {
    state: {
      list,
      employeesNFCList,
      ticketNFCList,
      memberShipList,
      page,
      perPage,
      count,
      length,
      countEmp,
      pageEmp,
      perPageEmp,
      lengthEmp,
      countTick,
      pageTick,
      perPageTick,
      lengthTick,
      countMemberShip,
      pageMemberShip,
      perPageMemberShip,
      lengthMemberShip,
    },
    fetchList: fetchNFC,
    fetchEmpNFCList,
    fetchTicketNFCList,
    fetchMemberShipNFCList,
    dispatch,
    remove,
  } = useNFC();

  const tabs = [
    {
      title: "NFC",
      num:
        name === "General"
          ? length
          : name === "Employees"
          ? lengthEmp
          : name === "MemberShip"
          ? lengthMemberShip
          : lengthTick,
    },
  ];

  const colsNFC = [
    {
      label: "Tag Code",
      name: "tagCode",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Tag Type",
      name: "tagType",
    },
    {
      label: "Serial Number",
      name: "serialNumber",
    },
    {
      label: "Note",
      name: "notes",
    },
    {
      label: "Status",
      name: "isActive",
      customRender: Active,
    },
  ];

  const colsEmpNFC = [
    {
      label: "employee Code",
      name: "employeeCode",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Full Name",
      name: "fullName",
    },
    { label: "Tag Code", name: "tagCode", customRender: TagCode },
    {
      label: "Tag Type",
      name: "tagType",
      customRender: TagType,
    },
  ];

  const colsTickNFC = [
    {
      label: "Number",
      name: "number",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Is Free",
      customRender: Free,
    },
    { label: "Tag Code", name: "tagCode", customRender: TagCode },
    {
      label: "Tag Type",
      name: "tagType",
      customRender: TagType,
    },
    {
      label: "Status",
      name: "isActive",
      customRender: Active,
    },
  ];

  const colsMemberNFC = [
    {
      label: "Member Name",
      name: "memberName",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Mobile",
      name: "mobile",
    },
    { label: "Tag Code", name: "tagCode", customRender: TagCode },
    {
      label: "Tag Type",
      name: "tagType",
      customRender: TagType,
    },
    {
      label: "Status",
      name: "isActive",
      customRender: Active,
    },
  ];

  const changePageSize = (size) => {
    dispatch({
      type:
        name === "General"
          ? "set_per_page"
          : name === "Employees"
          ? "set_per_pageEmp"
          : name === "MemberShip"
          ? "set_per_page_MemberShip"
          : "set_per_pageTick",
      payload: size,
    });
  };
  const getCols = () => {
    var col = [];
    switch (name) {
      case "General":
        col = colsNFC;
        break;
      case "Ticket":
        col = colsTickNFC;
        break;
      case "Employees":
        col = colsEmpNFC;
        break;
      case "MemberShip":
        col = colsMemberNFC;
        break;
      default:
        col = [];
        break;
    }
    return col;
  };

  const getList = () => {
    var ListReturned = new Array([]);
    switch (name) {
      case "General":
        ListReturned = list;
        break;
      case "Employees":
        ListReturned = employeesNFCList;
        break;
      case "Ticket":
        ListReturned = ticketNFCList;
        break;
      case "MemberShip":
        ListReturned = memberShipList;
        break;
      default:
        ListReturned = [];
        break;
    }
    return ListReturned;
  };

  const handleDelete = async (id, row) => {
    try {
      if (name === "General") {
        await remove(id);
      } else await remove(row?.tag?.id);
      setReload(!reload);
    } catch (error) {
      setError(
        error?.errors?.message ? error.errors.message : "some thing wrongs"
      );
    }
  };

  const getData = (name) => {
    const dataMap = {
      Company: [
        ...(companies?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      Site: [
        ...(sites?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      Plan: [
        ...(PlanEnum?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
    };

    return dataMap[name] || [];
  };

  useEffect(() => {
    if (role === "Admin") {
      fetchCompany();
    }
  }, [role]);
  useEffect(() => {
    if (role === "Company" && name !== "Ticket") {
      setValue("id", adminOn?.id);
    }
  }, [role, adminOn, setValue]);

  useEffect(() => {
    if (role === "Site" && name === "Ticket") {
      setValue("id", adminOn?.id);
    }
  }, [role, adminOn, setValue]);
  useEffect(() => {
    if (
      (role === "Admin" || role === "Company") &&
      CompanyId &&
      name === "Ticket"
    ) {
      fetchSites(CompanyId, 0);
    }
  }, [name, CompanyId, role]);

  useEffect(() => {
    if (role === "Company" && name === "Ticket") {
      fetchSites(adminOn?.id, 0);
    }
  }, [role, adminOn, name]);

  useEffect(() => {
    if (getValues("id") > 0 && name === "General") {
      fetchNFC(getValues("id"), page, perPage);
    }
  }, [getValues, page, perPage]);

  useEffect(() => {
    if (getValues("id") > 0 && name === "Employees") {
      fetchEmpNFCList(getValues("id"), pageEmp, perPageEmp);
    }
  }, [getValues, name, pageEmp, perPageEmp]);

  useEffect(() => {
    if (getValues("id") > 0 && name === "Ticket") {
      fetchTicketNFCList(getValues("id"), pageTick, perPageTick);
    }
  }, [getValues, name, pageTick, perPageTick]);

  useEffect(() => {
    if (getValues("id") > 0 && getValues("pid") && name === "MemberShip") {
      fetchMemberShipNFCList(
        getValues("id"),
        getValues("pid"),
        pageMemberShip,
        perPageMemberShip
      );
    }
  }, [getValues, name, pageMemberShip, perPageMemberShip]);

  const onSubmit = async (values) => {
    switch (name) {
      case "General":
        fetchNFC(values?.id, page, perPage);
        break;
      case "Employees":
        fetchEmpNFCList(values?.id, pageEmp, perPageEmp);
        break;
      case "Ticket":
        fetchTicketNFCList(values?.id, pageTick, perPageTick);
        break;
      case "MemberShip":
        fetchMemberShipNFCList(
          values?.id,
          values?.pid,
          pageMemberShip,
          perPageMemberShip
        );
        break;
      default:
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        {error && (
          <Alert severity="error" sx={{ width: "fit-content", my: 2 }}>
            {error}
          </Alert>
        )}
        <div style={{ width: "85%", background: "#f7f9fb" }}>
          <GridGroup1>
            {FilterFields.map((f, index) => (
              <React.Fragment key={index}>
                {role === "Company" && f.label === "Company" ? (
                  <Box mb={10}>
                    <span style={{ fontSize: "12px" }}>Company Name</span>

                    <Box
                      sx={{
                        borderBottom: "1px solid gray",
                        width: "290px",
                        borderRadius: "8px",
                        textAlign: "center",
                        marginTop: "20px",
                      }}
                    >
                      {adminOn?.companyName}
                    </Box>
                  </Box>
                ) : (
                  <>
                    {role === "Site" ? (
                      <>
                        {f.label === "Company" && (
                          <Box mb={10}>
                            <span style={{ fontSize: "12px" }}>
                              Company Name
                            </span>

                            <Box
                              sx={{
                                borderBottom: "1px solid gray",
                                width: "290px",
                                borderRadius: "8px",
                                textAlign: "center",
                                marginTop: "20px",
                              }}
                            >
                              {site?.company?.companyName}
                            </Box>
                          </Box>
                        )}
                        {f.label === "Site" && (
                          <Box mb={10}>
                            <span style={{ fontSize: "12px" }}>Site Name</span>

                            <Box
                              sx={{
                                borderBottom: "1px solid gray",
                                width: "290px",
                                borderRadius: "8px",
                                textAlign: "center",
                                marginTop: "20px",
                              }}
                            >
                              {adminOn?.siteName}
                            </Box>
                          </Box>
                        )}
                      </>
                    ) : (
                      <FormControl
                        sx={{
                          m: 1,
                          minWidth: 120,
                          marginBottom: "20px",
                          display:
                            f.label === "Site" && name === "Ticket"
                              ? "inline-block"
                              : f.label === "Plan" && name === "MemberShip"
                              ? "inline-block"
                              : f.label === "Company"
                              ? "inline-block"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {f.label}
                        </span>
                        <Select
                          displayEmpty
                          onChange={(e) => {
                            if (f.label === "Company") {
                              setCompanyId(e.target.value);
                            }
                          }}
                          defaultValue={0}
                          inputProps={{
                            ...register(f?.name),
                            "aria-label": "Without label",
                            autoFocus: true,
                          }}
                          sx={{
                            fontSize: "12px",
                            width: "300px",
                            height: "40px",
                            marginTop: "14px",
                          }}
                        >
                          {getData(f.label).map((company) => {
                            return (
                              <MenuItem key={company.id} value={company.id}>
                                {company.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                  </>
                )}
              </React.Fragment>
            ))}
          </GridGroup1>
          {role === "Admin" ? (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: theme.color.blackBackground,
                  color: "white",
                  mr: 5,
                  mb: 2,
                  "&:hover": { background: `${theme.color.blackBackground}` },
                  textTransform: "capitalize",
                }}
              >
                <FilterList />
                <span style={{ margin: theme.spacing(0, 2) }}>Filter</span>
              </Button>
            </Box>
          ) : (
            <>
              {role === "Company" &&
                (name === "Ticket" || name === "MemberShip") && (
                  <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        backgroundColor: theme.color.blackBackground,
                        color: "white",
                        mr: 5,
                        mb: 2,
                        "&:hover": {
                          background: `${theme.color.blackBackground}`,
                        },
                        textTransform: "capitalize",
                      }}
                    >
                      <FilterList />
                      <span style={{ margin: theme.spacing(0, 2) }}>
                        Filter
                      </span>
                    </Button>
                  </Box>
                )}
            </>
          )}
        </div>
      </form>
      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      />
      <CustomTable
        empty={getList()?.length === 0 ? true : false}
        cols={getCols()}
        data={getList()?.length !== 0 ? getList() : []}
        filters={{
          pagination: true,
          page:
            name === "General"
              ? perPage
              : name === "Employees"
              ? perPageEmp
              : name === "MemberShip"
              ? perPageMemberShip
              : perPageTick,
          changePageSize: changePageSize,
        }}
        actions={{
          delete: handleDelete,
        }}
        showButton={true}
        rowsPerPage={10}
        dispatch={dispatch}
        count={
          name === "General"
            ? count
            : name === "Employees"
            ? countEmp
            : name === "MemberShip"
            ? countMemberShip
            : countTick
        }
      ></CustomTable>
    </>
  );
};

export default NFCPage;
